/**
 * Figma tam/toggle, 52 x 32 (04 "Alertes de stationnement", 05b "Mode duo").
 * On: violet track, 24 px white knob on the right. Off: #e4deea track, 2 px #666665 ring, 16 px grey knob.
 */
export function Toggle(props: { checked: boolean; onChange: (v: boolean) => void; label: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={props.checked}
      aria-label={props.label}
      class={`relative h-8 w-[52px] shrink-0 rounded-full transition-colors ${props.checked ? "bg-violet" : "bg-[#e4deea] shadow-[inset_0_0_0_2px_#666665]"}`}
      onClick={() => props.onChange(!props.checked)}
    >
      <span
        class={`absolute top-1/2 -translate-y-1/2 rounded-full transition-all ${props.checked ? "left-6 h-6 w-6 bg-white" : "left-2 h-4 w-4 bg-text"}`}
      />
    </button>
  );
}
